import {Directive} from "@angular/core";
import {NgModel} from "@angular/forms";
import {ControlAccessors, InputModifierService} from "./input-modifier.service";

@Directive({
    selector: '[ngModel][toUpperCase]',
    host: {
        '(input)': 'onInput($event)'
    }
})
export class ToUppercaseTdDirective {

    constructor(private _model: NgModel, private _inputModifier: InputModifierService) {
    }

    onInput(event) {
        this._inputModifier.transformControlValue<string>(ControlAccessors.forTemplateDrivenForm(this._model),
            event, v => v.toUpperCase())
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/to-uppercase-td.directive.ts